import { RoomService } from '../../api/services/roomService';
import { getCookie } from '../../utils/cookies';
import { extractTotalCount } from '../../components/common/tableStyles';

export const rooms = {
    state: {
        list: [],
        total: 0,
        isLoading: false,
        error: null,
    },
    reducers: {
        setRooms(state, payload) {
            const list = payload.data || payload;
            const total = extractTotalCount(payload, list);
            return { ...state, list: Array.isArray(list) ? list : [], total };
        },
        setLoading(state, payload) {
            return { ...state, isLoading: payload };
        },
        setError(state, payload) {
            return { ...state, error: payload };
        },
        removeRoom(state, id) {
            return {
                ...state,
                list: state.list.filter(r => r.id !== id && r._id !== id),
                total: Math.max(0, state.total - 1)
            };
        },
    },
    effects: (dispatch) => ({
        async fetchRoomsAsync(params = {}, rootState) {
            dispatch.rooms.setLoading(true);
            try {
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                const data = await RoomService.getAll(params, tenantId);
                dispatch.rooms.setRooms(data);
            } catch (error) {
                console.error("Failed to fetch rooms", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        },
        async saveRoomAsync(roomData, rootState) {
            try {
                dispatch.rooms.setLoading(true);
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                await RoomService.save(roomData, tenantId);
                // Refresh list
                await dispatch.rooms.fetchRoomsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to save room", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        },
        async archiveRoomAsync(id, rootState) {
            try {
                dispatch.rooms.setLoading(true);
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                await RoomService.archive(id, tenantId);
                // Refresh list
                await dispatch.rooms.fetchRoomsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to archive room", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        },
        async setRoomOOOAsync({ id, payload }, rootState) {
            try {
                dispatch.rooms.setLoading(true);
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                await RoomService.setOOO(id, payload, tenantId);
                // Refresh list
                await dispatch.rooms.fetchRoomsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to set room out-of-order", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        },
        async bulkUpdateStatusAsync(payload, rootState) {
            try {
                dispatch.rooms.setLoading(true);
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                await RoomService.bulkUpdateStatus(payload, tenantId);
                // Refresh list
                await dispatch.rooms.fetchRoomsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to bulk update rooms", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        },
        async deleteRoomAsync(id, rootState) {
            try {
                dispatch.rooms.setLoading(true);
                dispatch.rooms.removeRoom(id);
                const tenantId = rootState.auth.user?.tenantId || JSON.parse(getCookie('adminAuth') || '{}').tenantId || '1';
                await RoomService.delete(id, tenantId);
                // Refresh list
                await dispatch.rooms.fetchRoomsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to delete room", error);
                dispatch.rooms.setError(error.message);
                throw error;
            } finally {
                dispatch.rooms.setLoading(false);
            }
        }
    })
};
